import React from "react";
import PropTypes from "prop-types";

import { IconButton, Menu as MenuMUI, MenuItem as MenuItemMUI, Tooltip } from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";

const MenuActions = ({
    options,
    maxHeight,
    width = "30ch",
    selected,
    handleClick,
    handleClose,
    handleClickItem,
}) => {
    /**
     * [Menu desplegable de acciones]
     * @param  {[array[string]]} options [Son las opciones del menu. Una lista de strings]
     * @param  {string,number} maxHeight [Es el tamaño maximo del menú. Opcional]
     * @param  {string,number} description [Es el ancho del menú. Por defecto es 30ch]
     * @param  {string} selected [En caso de tener un valor, representa la opción seleccionada por defecto en el menú]
     * @param  {function} handleClick [Funcion que se ejecuta al hacer click en el botón. Por defecto abre el menú]
     * @param  {function} handleClose [Opcional. Por defecto, cierra el menu. Se puede pasar otra funcion que haga algo más.]
     * @param  {[function]} handleClickItem [La acción a llevar a cabo cuando se clickea un ítem. Si el item tiene un handleClick propio, se ejecuta ese.]
     */

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClickDefault = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseDefault = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                onClick={(e) => {
                    handleClick && handleClick(e);
                    handleClickDefault(e);
                }}
                size="large"
            >
                <MoreVertIcon />
            </IconButton>
            <MenuMUI
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={(e) => {
                    handleClose && handleClose(e);
                    handleCloseDefault(e);
                }}
                PaperProps={{
                    style: {
                        maxHeight: maxHeight,
                        width: width,
                    },
                }}
            >
                {options
                    .filter((o) => !o.hide)
                    .map((option) => {
                        const item = (
                            <MenuItemMUI
                                key={option.label}
                                selected={selected || option.selected}
                                onClick={option.handleClick || handleClickItem}
                                disabled={option.disabled}
                                style={{ pointerEvents: option.disabled ? "none" : "auto" }}
                            >
                                {option.label}
                            </MenuItemMUI>
                        );
                        const menuItemSpan = <span>{item}</span>;

                        return option.tooltipTitle ? (
                            <Tooltip
                                key={option.label}
                                title={option.tooltipTitle}
                                enterTouchDelay={0}
                                leaveTouchDelay={15000}
                                disableTouchListener={false}
                            >
                                {menuItemSpan}
                            </Tooltip>
                        ) : (
                            item
                        );
                    })}
            </MenuMUI>
        </div>
    );
};

MenuActions.propTypes = {
  options: PropTypes.array.isRequired,
  selected: PropTypes.string,
  maxHeight: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  handleClick: PropTypes.func,
  handleClose: PropTypes.func,
  handleClickItem: PropTypes.func,
};

export default MenuActions;
